import BaseBlock from "./BaseBlock";
import Hero from "./Hero";
import Testimonials from "./Testimonials";
import Slider from "./Slider";
import TextWithMedia from "./TextWithMedia";
import BeforeAfterGallery from "./BeforeAfterGallery";
import Vote from "./Vote";
import WpImage from "./Core/WpImage";

export default class Initializer {
	constructor() {

		this.initBlocks();

		const hasOverlappingComponents = this.adjustOverlappingComponents();

		this.addNecessaryCssClasses();

		if (hasOverlappingComponents) {
			window.addEventListener("resize", this.adjustOverlappingComponents.bind(this), {
				passive: true,
				once: false
			});
		}
	}

	initBlocks() {
		const blocks = this.getBlocks();
		for (let cls in blocks) {
			window.document.querySelectorAll(cls).forEach((el, index) => {
				const Block = blocks[cls];
				let block = new Block(el, index);
				if (block instanceof BaseBlock) {
					block = this.initBlock(block);
					block.init();
				}
			});
		}
	}

	/**
	 * Override this method to set up predefined blocks.
	 * See child theme for example
	 *
	 * @param {BaseBlock} block
	 * @return {BaseBlock}
	 */
	initBlock(block) {
		return block;
	}

	addNecessaryCssClasses() {
		/**
		 *
		 * @type {NodeListOf<HTMLElement>}
		 */
		const $sections = document.querySelectorAll("section.acf-block");

		$sections.forEach(section => {
			if (section.querySelector(".section-background")) {
				section.classList.add("has-background");
			} else {
				section.classList.add("no-background");
			}
		});
	}

	adjustOverlappingComponents() {
		/**
		 *
		 * @type {NodeListOf<HTMLElement>}
		 */
		const $comps = document.querySelectorAll("section.acf-block.overlapping");

		$comps.forEach(
			(item, index) => {
				let $prevSection = item.previousElementSibling;
				if ($prevSection && $prevSection.classList.contains("acf-block")) {
					$prevSection.style.paddingBottom = "";
					$prevSection.classList.add("overlapped");
					let marginTop = window.parseInt(item.style.marginTop);
					if (marginTop < 0) {
						let prevSectionPaddingBottom = window.parseInt($prevSection.style.paddingBottom);
						if (prevSectionPaddingBottom > 0) {
							$prevSection.style.paddingBottom = prevSectionPaddingBottom + Math.abs(marginTop) + "px";
						}
					}

					if (item.classList.contains("next-block-slides-under")) {
						let $nextSection = item.nextElementSibling;
						if ($nextSection && $nextSection.classList.contains("acf-block")) {
							$nextSection.style.marginTop = "";
							$nextSection.style.zIndex = "";
							$nextSection.style.paddingTop = "";

							let nextSectionPaddingTop = window.parseInt($nextSection.style.paddingTop);
							let offset = -item.clientHeight - marginTop;

							if (nextSectionPaddingTop > 0) {
								$nextSection.style.paddingTop = nextSectionPaddingTop + Math.abs(offset) + "px";
							}
							$nextSection.style.marginTop = `${offset}px`;
							$nextSection.style.zIndex = item.style.zIndex - 1;
						}
					}
				}
			}
		);

		return $comps.length > 0;
	}

	/**
	 * Override this method the register new or delete predefined blocks
	 *
	 * @return {{".thee-block-slider": Slider, ".thee-block-vote": Vote, ".thee-block-text-with-media": TextWithMedia, ".thee-block-hero": Hero, ".thee-block-testimonials": Testimonials, ".thee-block-before-after-gallery": BeforeAfterGallery, ".wp-block-image"}}
	 */
	getBlocks() {
		return {
			".wp-block-image": WpImage,
			".thee-block-hero": Hero,
			".thee-block-testimonials": Testimonials,
			".thee-block-slider": Slider,
			".thee-block-text-with-media": TextWithMedia,
			".thee-block-before-after-gallery": BeforeAfterGallery,
			".thee-block-vote": Vote
		};
	}
}
